import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 70px;
`;
export const ContainerHead = styled.div`
  margin-top: 28px;
  text-align-last: center;
`;
export const Title = styled.div`
  font-weight: 700;
  font-size: 30px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.024em;
  color: #000000;
  margin-top: 16px;

  @media screen and (max-width: 768px) {
    width: 328px;
    margin: auto;
    margin-top: 16px;
  }
`;

export const ContainerBody = styled.div`
  display: grid;
  justify-content: center;
  margin-top: 40px;
  gap: 24px;
`;

export const Description = styled.div`
  width: 328px;
  height: 60px;
  left: 16px;
  top: 460px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #555a64;

  strong {
    color: black;
  }
`;

export const Label1 = styled.div`
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #6c757d;
`;

export const Label2 = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.008em;
  color: #000000;
`;

export const BoxInformativeToPay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 32px;
  width: 328px;
  height: 64px;
  background: #ffffff;
  border-radius: 8px;
`;

export const Label3 = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #6c757d;
  width: 328px;
`;

export const ActionsBarRoot = styled.div<{
  bgColor?: string;
  flexDirection?: string;
  border?: string;
  height?: string;
  margin?: string;
}>`
  background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.colors.bgNavbarPrimary)};
  height: ${(props) => (props.height ? props.height : '80px')};
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 794px;
  border-radius: 24px 24px 0 0;
  gap: 8px;
  min-height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;

  & button {
    max-width: 500px;
    margin: auto;
  }

  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.flexDirection && `flex-direction: ${props.flexDirection}`};
  ${(props) => props.border && `border: ${props.border}`};
`;
